import styled, { keyframes } from 'styled-components';
import { Grid, Box } from '@mui/material';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled(Grid)`
  display: grid;
  place-items: center;

  height: 100%;
  overflow: auto;
  animation: ${fadeIn} 0.5s ease-in;
`;

export const Wrapper = styled(Box)`
  padding: 0 2rem;
  color: ${({ theme }) => theme.colors.white};
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

export const CreateAccountText = styled.p`
  color: ${({ theme }) => theme.colors.yellow};
  text-decoration: underline;
`;

export const TopDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  width: 100%;

  p {
    font-size: 2.6rem;
    font-weight: 400;
    font-family: 'Inter', sans-serif;

    span {
      font-size: 2.6rem;
      font-weight: 700;
    }
  }

  p:not(:last-child) {
    font-size: 1.6rem;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 10rem;
  padding: 0 2rem;
  border: none;
  color: ${({ theme }) => theme.colors.blackText};
  font-size: 1.4rem;
  height: 4rem;
  min-width: 30rem;
`;
